import { encodeText } from '@svta/cml-utils'
import type { WebVttSourceLabelBox } from '../boxes/WebVttSourceLabelBox.ts'
import { IsoBoxWriteView } from '../IsoBoxWriteView.ts'

/**
 * Write a `WebVttSourceLabelBox` to an `IsoBoxWriteView`.
 *
 * @param box - The `WebVttSourceLabelBox` fields to write
 *
 * @returns An `IsoBoxWriteView` containing the encoded box
 *
 * @public
 */
export function writeVlab(box: WebVttSourceLabelBox): IsoBoxWriteView {
	const sourceLabelBytes = encodeText(box.sourceLabel)

	const headerSize = 8
	const sourceLabelSize = sourceLabelBytes.length + 1 // null-terminated
	const totalSize = headerSize + sourceLabelSize

	const writer = new IsoBoxWriteView('vlab', totalSize)
	writer.writeUtf8TerminatedString(box.sourceLabel)

	return writer
}
